import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { fmtEuro } from "@/lib/format";

export const BudgetAlerts = ({ alerts, year }) => {
  if (!alerts?.count) return null;
  return (
    <div className="rounded-2xl border border-[#991B1B]/30 bg-[#FEF2F2] p-5" data-testid="dashboard-budget-alerts">
      <div className="flex items-center gap-2 text-[#991B1B]">
        <AlertTriangle className="h-4 w-4" />
        <span className="text-sm font-semibold">
          Υπέρβαση προϋπολογισμού {year} — {alerts.months.length} μήνες, {alerts.departments.length} τμήματα
        </span>
      </div>
      <div className="mt-2 flex flex-wrap gap-2 text-xs">
        {[...alerts.months, ...alerts.departments].slice(0, 8).map((a) => (
          <span key={a.type + a.name} className="rounded-full bg-white border border-[#991B1B]/20 px-3 py-1 text-[#45423C]">
            {a.name} <span className="tabular font-semibold text-[#991B1B]">+{fmtEuro(a.over)}</span>
          </span>
        ))}
      </div>
      <Link to="/budget" data-testid="dashboard-alerts-link" className="inline-block mt-3 text-xs font-semibold text-[#C86235] hover:underline">Προβολή προϋπολογισμού →</Link>
    </div>
  );
};
